"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoiceItemModalBody = InvoiceItemModalBody;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const FormContext_1 = require("../../../View/Modals/FormContext");
const InvoiceDetails_1 = require("../InvoiceDetails/InvoiceDetails");
const MainSetupReact_1 = __importDefault(require("../../../React/MainSetupReact"));
const GenericComponents_1 = require("../../../View/Modals/CommonFormComponents/GenericComponents");
function InvoiceItemModalBody({ initialData }) {
    const { register, reset, watch, formState: { errors }, trigger, } = (0, FormContext_1.useFormContext)();
    const { invoice } = (0, InvoiceDetails_1.useInvoice)();
    const descriptionLength = watch("description")?.length || 0;
    (0, react_1.useEffect)(() => {
        console.log("InvoiceModalBody useEffect", initialData);
        const resetData = {
            _parent: initialData?._parent || invoice,
            description: initialData?.description || "",
            quantity: initialData?.quantity || 1,
            unitPrice: initialData?.unitPrice,
            vatTax: initialData?.vatTax || 23,
            _editor: MainSetupReact_1.default.getCurrentUserAsPerson(),
        };
        reset(resetData);
        trigger();
    }, [initialData, reset]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "description" },
            react_1.default.createElement("div", { className: "d-flex justify-content-between align-items-center" },
                react_1.default.createElement(react_bootstrap_1.Form.Label, { className: "mb-0" }, "Opis"),
                react_1.default.createElement(react_bootstrap_1.Form.Text, { className: `mb-0 ${descriptionLength >= 512 ? "text-danger" : "text-muted"}` },
                    descriptionLength,
                    "/512 znak\u00F3w")),
            react_1.default.createElement(react_bootstrap_1.Form.Control, { as: "textarea", rows: 4, maxLength: 512, placeholder: "Dodaj komentarz", isValid: !errors?.description, isInvalid: !!errors?.description, ...register("description") }),
            react_1.default.createElement(GenericComponents_1.ErrorMessage, { name: "description", errors: errors })),
        react_1.default.createElement(react_bootstrap_1.Row, null,
            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Col, controlId: "quantity" },
                react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Ilo\u015B\u0107"),
                react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "number", min: "1", isValid: !errors?.quantity, isInvalid: !!errors?.quantity, ...register("quantity") }),
                react_1.default.createElement(GenericComponents_1.ErrorMessage, { name: "quantity", errors: errors })),
            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Col, controlId: "unitPrice" },
                react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Cena jedn."),
                react_1.default.createElement(GenericComponents_1.ValueInPLNInput, { name: "unitPrice" })),
            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Col, controlId: "vatTax" },
                react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Stawka VAT"),
                react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "number", min: "1", isValid: !errors?.vatTax, isInvalid: !!errors?.vatTax, ...register("vatTax") }),
                react_1.default.createElement(GenericComponents_1.ErrorMessage, { name: "vatTax", errors: errors })))));
}
